import React, { useState } from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import LzSApp from '@lz-app/App';
import useLzFApiCall from '@lz-services/Api';
import { useLzOnMount } from '@lz-services/Hooks';
import { useLzFCheckRights } from "@lz-services/Utils";
import LzXInfoBox from '@lz-widgets/InfoBox';
import LzXSpinner from '@lz-components/commons/Spinner';

function UserDashboardScreen() {

  const [dashboardData, setDashboardData] = useState(null);

  const apiCall = useLzFApiCall();

  const load = async () => {
    const data = await apiCall('dashboard-data');

    if (data) {
      setDashboardData(data);
    }
  };

  // Call only for the first time when component is initially loaded
  useLzOnMount(() => {
    load();
  });

  const checkRights = useLzFCheckRights();

  // console.log('DD', dashboardData);

  return (
    <LzSApp.WrapperTemplate private screenTitle="Dashboard">

      {dashboardData ?
        <React.Fragment>
          <Container>
            <Grid container spacing={2}>
              {dashboardData?.stats &&
                <Grid size={{ xs: 12 }}>
                  <h2>System Statistics</h2>
                  <Grid container spacing={2}>
                    {checkRights('params.parties.list') &&
                      <Grid size={{ xs: 3 }}>
                        <LzXInfoBox green heading="Parties" count={dashboardData.stats.parties || 0} route='/params/parties' />
                      </Grid>
                    }
                    {checkRights('params.items.list') &&
                      <Grid size={{ xs: 3 }}>
                        <LzXInfoBox purple heading="Items" count={dashboardData.stats.items || 0} route='/params/items' />
                      </Grid>
                    }
                    {checkRights('content.sales_invoices.list') &&
                      <Grid size={{ xs: 3 }}>
                        <LzXInfoBox primary dark heading="Sales Invoices" count={dashboardData.stats.sales_invoices || 0} route='/content/sales-invoices' />
                      </Grid>
                    }
                    {checkRights('content.sales_invoices.list') &&
                      <Grid size={{ xs: 6 }}>
                        <LzXInfoBox red dark heading="Sales Invoices pending FBR Approval" count={dashboardData.stats.fbr_pending_sinvs || 0} route='/content/sales-invoices?onlyFbrPending=1' />
                      </Grid>
                    }
                    {checkRights('system.users.list') &&
                      <Grid size={{ xs: 3 }}>
                        <LzXInfoBox secondary dark heading="Users" count={dashboardData.stats.users || 0} route='/system/users' />
                      </Grid>
                    }
                  </Grid>
                </Grid>
              }
            </Grid>
          </Container>
        </React.Fragment>
        :
        <LzXSpinner />
      }

    </LzSApp.WrapperTemplate>
  );
}

export default UserDashboardScreen;
